import { createContext, useContext } from 'react';
import type { AppLocales } from '@hub/common';

export type StartFlowApi = {
  active: boolean;
  /** The sign-in token's language; kept once set. */
  setLocale: (locale: AppLocales) => void;
  /** The signed-in user's saved language; replaces the token's. */
  setSavedLocale: (locale: AppLocales) => void;
  end: () => void;
};

export const StartFlowContext = createContext<StartFlowApi>({
  active: false,
  setLocale: () => undefined,
  setSavedLocale: () => undefined,
  end: () => undefined,
});

export const useStartFlow = (): StartFlowApi => useContext(StartFlowContext);
